import { Button, Grid } from '@mui/material';
import React, { Dispatch, SetStateAction } from 'react';
import arrowLeft from '../../../assets/image/arrowleft.png';

import filterIcon from '../../../assets/image/filter.png';
import { useNavigate } from 'react-router-dom';
import HeaderTitle from './HeaderTitle';
import { makeStyles } from '@mui/styles';
import { useMediaQueryState } from '../../../hooks/useMediaQueryState';
import TopHeaderDesktop from './TopHeaderDesktop';

export interface TopHeaderProps {
  isBackIcon?: boolean;
  isTuneIcon?: boolean;
  onClickTuneIcon?: () => void;
}

function TopHeader({ isBackIcon, isTuneIcon, onClickTuneIcon }: TopHeaderProps) {
  const { isPC } = useMediaQueryState();
  const classes = useStyles();
  const navigate = useNavigate();
  const handleClickArrowBtn = () => {
    navigate(-1);
  };

  if (isPC) {
    return <TopHeaderDesktop isTuneIcon={isTuneIcon} onClickTuneIcon={onClickTuneIcon} />;
  }

  return (
    <Grid container textAlign={'center'} alignItems={'center'} justifyContent={'space-around'} style={{ marginTop: '43px', marginBottom: '11px' }}>
      <Grid item alignItems={'center'} sx={{ marginTop: '6px', cursor: 'pointer' }}>
        {isBackIcon ? <img src={arrowLeft} onClick={handleClickArrowBtn} alt='backIcon' /> : <></>}
      </Grid>
      <Grid item>
        <HeaderTitle />
      </Grid>
      <Grid item sx={{ marginTop: '6px', cursor: 'pointer' }}>
        {isTuneIcon ? <img src={filterIcon} onClick={onClickTuneIcon} alt='filterIcon' /> : <></>}
      </Grid>
    </Grid>
  );
}

const useStyles = makeStyles({
  boxdot: {
    width: '270px',
    height: '124px',
  },
});

export default TopHeader;
